import { Injectable } from '@angular/core';
import {
  PRIMARY_OUTLET,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlSegmentGroup,
  UrlTree,
} from '@angular/router';
import { PlatformEnum, getPlatform } from '@interfaces/platform/platform.enum';
import { UserInterface } from '@interfaces/user/user.interface';
import { NavController } from '@ionic/angular';
import { AbstractAuthGuard } from '@services/abstract/abstract.auth.guard';
import { AuthService } from '@services/auth/auth.service';

interface NextRoutesInterface {
  [key: string]: {
    mobile: string;
    desktop: string;
  };
}

const nextRoutes: NextRoutesInterface = {
  familiar: {
    mobile: 'menu',
    desktop: 'general',
  },
  academy: {
    mobile: 'management',
    desktop: 'management/profile',
  },
};

@Injectable()
export class PlatformGuard extends AbstractAuthGuard {
  constructor(
    protected authService: AuthService,
    protected router: Router,
    protected navCtrl: NavController,
  ) {
    super(authService, router);
  }

  protected check(user: UserInterface, state: RouterStateSnapshot): boolean {
    const urlParsed: UrlTree = this.router.parseUrl(state.url);
    const urlPrimary: UrlSegmentGroup = urlParsed.root.children[PRIMARY_OUTLET];
    const urlSegments: UrlSegment[] = urlPrimary.segments;
    const inMainRoute: boolean = urlSegments.length === 1;
    const platform: PlatformEnum = getPlatform();

    if (inMainRoute) {
      const nextRoute: string[] = nextRoutes[user.role][platform].split('/');
      const newUrlSegments: string[] = ['admin', user.role, ...nextRoute];
      const newPath: UrlTree = this.router.createUrlTree(newUrlSegments);
      this.navCtrl.navigateRoot(newPath);
      return false;
    }

    return true;
  }

  protected onError(error): boolean {
    return false;
  }
}
